<template>
    <div class='profile-text-edit-modal'>
        <b-modal :active="true" :canCancel="false">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Rediger studerendes profiltekster</p>
                </header>

                <section class="modal-card-body">
                    <b-field :label="$t('global.forms.short')"
                             :type="{'is-danger': veeErrors.has('short')}"
                             :message="veeErrors.first('short')">
                        <b-input v-model="editableStudent.short" name="short"
                                 v-validate="'max:75'" :data-vv-as="$t('global.forms.short')" />
                    </b-field>

                    <hr>

                    <h2 class="subtitle">Profiltekst</h2>

                    <vue-editor :editorToolbar="$options.toolbarOptions" id="about" name="about"
                                v-model="editableStudent.about" :data-vv-as="'Profilteksten'"
                                v-validate="'required|min_stripped_length:100|max_stripped_length:1500'"/>

                    <p v-if="veeErrors.has('about')" class="help is-danger">{{veeErrors.first('about')}}</p>
                </section>

                <footer class="modal-card-foot">
                    <button class="button" @click="close" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-primary" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any()">Gem</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

</style>

<script>
    import StudentService from '@/taskflex/students/services/StudentService';
    import { VueEditor } from 'vue2-editor';

    export default {
        data() {
            return {
                editableStudent: null,
                isSubmitting: false,
            };
        },

        props: {
            student: {
                type: Object,
                required: true,
            },
        },

        mounted() {
            this.editableStudent = Object.assign({}, this.student);
        },

        toolbarOptions: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['link', 'clean'], // remove formatting button
        ],

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const student = this.editableStudent;

                const options = {
                    about: student.about,
                    short: student.short,
                };

                this.isSubmitting = true;

                StudentService.update(this.student.id, options, ({ data }) => {
                    this.isSubmitting = false;

                    // Set the returned values that we updated, as well as the slug.
                    student.about = data.about;
                    student.short = data.short;

                    this.$emit('updated', student);
                    this.$emit('close');
                });
            },

            close() {
                this.$emit('close');
            },
        },

        components: {
            VueEditor,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/students/ProfileTextEditModal.vue